import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import useSocket from "src/_common/hooks/useSocket";
import {
  useAppEvenListSelector,
  useAppEventGameListSelector,
  useAppPerformanceListSelector,
} from "src/_common/hooks/selectors/eventSelector";
import {
  CRYPTO_SECRET_KEY,
  SOCKET_URL,
  SOCKET_CHANNEL,
  SOCKET_TRANSPORTS
} from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { toast } from "react-toastify";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import clsx from "clsx";
import Sponsor from "src/components/common/Sponsor";
import ProgressBar from "src/components/common/ProgressBar";
import Cryptr from "cryptr";
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventTaskPage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const eventAction = useAppEventAction();
  const userDetails = useAppUserDetailsSelector();
  const eventGameListSelector = useAppEventGameListSelector() as Array<{
    id?: number;
    ispicked?: number;
    status?: number;
    title?: string;
    scan_user_count?: number;
  }> | null;
  const { eventId, performanceId } = useParams<{ eventId?: string; performanceId?: string }>();
  const e_id: number = parseInt(cryptr.decrypt(eventId || ''));
  const eventListSelector = useAppEvenListSelector() as { game_details?: { id?: number } } | null;
  const guestUserId = useAppGuestUserIdSelector();
  const [performanceInfo, setPerformanceInfo] = useState<{ id?: number; title?: string } | null>(null);
  const performanceList = useAppPerformanceListSelector() as Array<{ id?: number; title?: string }> | null;
  const [progressPercent, setProgressPercent] = useState<number>(0);

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
    transports: SOCKET_TRANSPORTS,
    upgrade: true,        // Enable transport upgrades (polling -> websocket)
    rememberUpgrade: true, // Remember successful upgrades for faster reconnection
  });

  useEffect(() => {
    socket.connect();

    //Status Change Socket
    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: Record<string, unknown>) => {
      eventAction.pushGameStatusChangeSocketDataIntoGameList(changeEventStatus);
    });

    //Status Message Change Socket
    // socket.on(SOCKET_CHANNEL.STATUS_MESSAGE, (statusMessage: any) => {
    //     console.log({statusMessage})
    //     eventAction.pushGameStatusMessageSocketDataIntoStatusList(statusMessage, userDetails.id)
    // });
    // }

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: Record<string, unknown> & { rodeo_event_id?: number }) => {
      if (changeEventStatus && changeEventStatus.rodeo_event_id && guestUserId) {
        // Handle guest user event status
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  const getEventGameList = () => {
    const params: { rodeo_event_id: number; game_id?: number; performance_id: number; guest_user_id?: string } = {
      rodeo_event_id: e_id,
      game_id: eventListSelector?.game_details?.id,
      performance_id: parseInt(cryptr.decrypt(performanceId || '')),
    };
    const p = performanceList?.find((x) => x.id == params.performance_id);
    console.log({ p, performanceList });
    setPerformanceInfo(p ?? null);
    if (!userDetails) {
      if (guestUserId) {
        params["guest_user_id"] = guestUserId;
      }
    }
    eventApi.callGetEventGameList(
      params as Record<string, unknown>,
      (_message: string, resp: unknown) => {
        // console.log({resp})
        if (resp && typeof resp === "object") {
          const respData = resp as { rodeo_event_dtls?: { login_required?: number }; progress?: number };
          if (respData.rodeo_event_dtls?.login_required !== undefined) {
            // Removed setLoginReq - loginReq was unused
          }
          if (respData.progress !== undefined) {
            setProgressPercent(respData.progress);
          }
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const goToTaskDetailsPage = (e: React.MouseEvent<HTMLAnchorElement>, task?: number) => {
    e.preventDefault();
    if (!task) {
      return;
    }
    const taskId = cryptr.encrypt(task);
    history.push(`/event/${eventId}/${performanceId}/${taskId}`);
  };

  useEffect(() => {
    getEventGameList();
  }, []);

  useEffect(() => {
    // Removed loginReq check - loginReq was unused
  }, []);

  const goToLeaderBoardPage = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    history.push(`/result/${eventId}/${performanceId}`);
  };

  const goToDaysPage = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    history.push(`/performances/${eventId}`);
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <h2 className="top-two-btns has-leaderboard">
        {/* {!isInsideRodeoTokenExists ? ( */}
        <a onClick={goToDaysPage} className="dual-btn" style={{ cursor: "pointer" }}>
          Days
        </a>
        {/* ) : null} */}
        {eventGameListSelector && eventGameListSelector.length > 0 ? (
          <Link to="#" className="dual-btn" onClick={(e) => goToLeaderBoardPage(e)}>
            Progress Board
          </Link>
        ) : null}
      </h2>
      <hr className="color-white" />
      {progressPercent > 0 && <ProgressBar progressPercent={progressPercent} />}
      <div className="text-white text-center pt-3">{performanceInfo?.title?.toUpperCase()}</div>
      <div className="ready-msg-wrap">
        <a onClick={goBack} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </a>
        Pick your task and scan the QR code
      </div>
      <ul className="list-style rodeo-inside-list">
        {eventGameListSelector && eventGameListSelector.length ? (
          eventGameListSelector.map((event) => (
            <li
              key={event?.id}
              className={clsx({
                voted: event?.ispicked,
              })}
            >
              <a
                className={clsx({
                  "ripple-effect not-started-yet d-flex": event?.status === 0,
                  "ripple-effect on-going-game d-flex": event?.status === 1,
                  "ripple-effect event-end d-flex": event?.status === 2,
                })}
                onClick={(e) => goToTaskDetailsPage(e, event?.id)}
                // onClick={() => openQrscannerModal(event)}
              >
                <span className="event-info task-span">
                  <span className="d-inline-block event-title">{event?.title}</span>
                  {/* <img src="/images/qr_scanner.png" /> */}
                  {(event?.scan_user_count ?? 0) > 0 && <span className="task-scanned"></span>}
                </span>
              </a>
            </li>
          ))
        ) : (
          <div className="no-text text-white text-center">No tasks available</div>
        )}
      </ul>
      <Sponsor />
      {/* {showQrscannerModal && selectedTask && (
        <QrscannerModal shouldShow={showQrscannerModal} onClose={closeQrscannerModal} taskDetails={selectedTask} />
      )} */}
    </React.Fragment>
  );
}
